import { domain } from 'modules/data';

import { messages } from './ButtonNext.messages';

export const useButtonNext = (integrationType: domain.IntegrationType) => {
    switch (integrationType) {
        case domain.IntegrationType.Xero:
            return {
                buttonText: messages.xeroButton,
            };
        case domain.IntegrationType.NetSuite:
            return {
                buttonText: messages.netSuiteButton,
            };
        default:
            return {
                buttonText: messages.nextButton,
                minWidth: 180,
            };
    }
};
